import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { IonButton, IonButtons, IonIcon } from '@ionic/angular';
import { LoginService } from '../../../services/login.service';

@Component({
    selector: 'app-auth-status',
    templateUrl: './auth-status.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonButtons, IonButton, IonIcon, CommonModule],
})
export class AuthStatusComponent implements OnInit {
    @Input() color = 'primary';

    constructor(public auth: AuthService, public loginService: LoginService) {}

    ngOnInit() {}
}
